

























































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

interface Column {
  text:string,
  value:string,
  index:number,
  help:string,
  helpFull:string,
  disabled:boolean,
  selected:boolean,
  isCustomColumn:boolean,
  planLimits: keyof BillingLimits,
}
@Component({})
export default class ColumnsSettingsDialogColumn extends Vue {
  @Prop()
  item: Column;
  
  @Prop()
  groupIndex: number;
  
  @Prop()
  getHelp: Function;
  
  @Prop()
  onDelete: Function;
  
  @Prop()
  reportMetricsName: Function;
  
  @Prop()
  onAddNewColumn: Function;
  
  @Prop()
  selectedMetricsChanged: Function;
  
  @Prop()
  selectedMetrics: boolean[];
}
